import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {DownloadMode} from 'common/report/constants';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';

import {FormattedReportMeta, ReportMeta} from './types';
import {template} from './template';
import css from './index.styl?inline';

const DOWNLOAD_DATE_FORMAT = `MMM D, YYYY`;

export type DownloadWrapperAttrs = {
  meta: ReportMeta;
  mode: DownloadMode;
};

export type DownloadWrapperProps = {
  attrs?: DownloadWrapperAttrs;
};
export class DownloadWrapper extends Component<EmptyObj, DownloadWrapperAttrs> {
  static get attrsSchema(): AttrsSchema<DownloadWrapperAttrs> {
    return {
      ...super.attrsSchema,
      meta: {type: `json`, description: `interface: ReportMeta`, required: true},
      mode: {type: `number`, description: `enum: DownloadMode`, required: true, default: 0},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        getFormattedReportMeta: () => this.getFormattedReportMeta(),
        getReportLocation: () => this.getReportLocation(),
        isFileDownload: () => this.attr(`mode`) === DownloadMode.File,
      },
    };
  }

  // Used by slack app, change carefully
  public getFormattedReportMeta(): FormattedReportMeta {
    const {title, dateRange, subtitles, reportName, analysisType, isEmpty} = this.getJSONAttribute(
      `meta`,
    ) as ReportMeta;
    const {from, to} = new DateRange(dateRange).getCalendarDates(DOWNLOAD_DATE_FORMAT);
    const reportTypeSubtitle = analysisType ? `${reportName}, ${analysisType}` : reportName;

    return {
      title,
      isEmpty,
      fromDate: from,
      toDate: to,
      subtitles: [reportTypeSubtitle, ...subtitles],
    };
  }

  // Screenshot host in puppeteer is web-internal, so we need to reconstruct the link
  private getReportLocation() {
    const url = new URL(window.location.toString());
    url.host = url.searchParams.get(`request_origin`) || `mixpanel.com`;
    url.searchParams.delete(`download`);
    url.protocol = `https:`;
    return url.href;
  }
}

export const DownloadWrapperEl = defineAndMakeJsxFactory<DownloadWrapperProps>(`mp-download-wrapper`, DownloadWrapper);
